module.exports = __webpack_public_path__ + "static/media/share.1d440d40.png";